import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class SubForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <label className="form-control-label">訂閱內容</label>
        <div
          className="mb-3"
          style={{
            border: "1px solid",
            borderColor: "#cccccc",
            borderRadius: "4px",
          }}
        >
          <div className="d-flex justify-content-around py-4">
            <div className="px-2 py-1" style={{ flex: 1 }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-1"
                  id="check-1"
                  type="checkbox"
                  checked={this.props.data ? this.props.data.news : false}
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"news"}
                />
                <label className="custom-control-label" htmlFor="check-1">
                  新聞
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-2"
                  id="check-2"
                  type="checkbox"
                  checked={
                    this.props.data ? this.props.data.classified_ads : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"classified_ads"}
                />
                <label className="custom-control-label" htmlFor="check-2">
                  分類報告
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-3"
                  id="check-3"
                  type="checkbox"
                  checked={this.props.data ? this.props.data.businesses : false}
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"businesses"}
                />
                <label className="custom-control-label" htmlFor="check-3">
                  商業
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-4"
                  id="check-4"
                  type="checkbox"
                  checked={
                    this.props.data ? this.props.data.southern_plaza : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"southern_plaza"}
                />
                <label className="custom-control-label" htmlFor="check-4">
                  美南廣場
                </label>
              </div>
            </div>

            <div className="px-2 py-1" style={{ flex: 1 }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-5"
                  id="check-5"
                  type="checkbox"
                  checked={this.props.data ? this.props.data.tv : false}
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"tv"}
                />
                <label className="custom-control-label" htmlFor="check-5">
                  電視
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-6"
                  id="check-6"
                  type="checkbox"
                  checked={this.props.data ? this.props.data.events : false}
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"events"}
                />
                <label className="custom-control-label" htmlFor="check-6">
                  活動
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-7"
                  id="check-7"
                  type="checkbox"
                  checked={this.props.data ? this.props.data.lives : false}
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={"lives"}
                />
                <label className="custom-control-label" htmlFor="check-7">
                  生活資訊
                </label>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SubForm;
